import React, { useEffect, useState, useSyncExternalStore } from 'react';
import { ChatFilter, getChatFilterName } from '../../../models/ChatFilter';
import { useTextSearch } from '../../../hooks/useTextSearch';
import { InputSearch } from '../../../components/InputSearch';
import { Button, ButtonSize } from '../../../components/Button';
import { ButtonVariant } from '../../../config/colors';
import { filtersUnreadStore } from './filtersUnreadStore';

interface ChatListViewHeaderProps {
  selectedFilter: ChatFilter;
  handleFilterChange: (filter: ChatFilter) => void;
  handleFilterDoubleClick: (filter: ChatFilter) => void;
}

export const ChatListViewHeader: React.FC<ChatListViewHeaderProps> = ({
  selectedFilter, 
  handleFilterChange,
  handleFilterDoubleClick
}) => {
  const { setTextSearch, setIsTextInputFocused } = useTextSearch();
  const [textSearchLocal, setTextSearchLocal] = useState('');
  const filtersUnread = useSyncExternalStore(
    (listener) => filtersUnreadStore.subscribe(listener),
    () => filtersUnreadStore.getSnapshot(),
    () => []
  );

  useEffect(() => {
    const handler = setTimeout(() => {
      setTextSearch(textSearchLocal);
    }, 500); 

    return () => clearTimeout(handler);
  }, [setTextSearch, textSearchLocal]);

  return (
    <div>
      <div className="px-4 pb-4">
        <InputSearch
          placeholder="Search"
          value={textSearchLocal}
          onClear={() => setTextSearchLocal('')}
          onChange={(e) => setTextSearchLocal(e.target.value)}
          onFocus={() => setIsTextInputFocused(true)}
          onBlur={() => setIsTextInputFocused(false)}
        />
      </div>

      <div className="px-4 pb-4">
        <div className="flex space-x-2 overflow-x-auto scrollbar-hide">
          {
            Object.values(ChatFilter).map((filter) => (
              <Button 
                  key={filter} 
                  variant={filter === selectedFilter ? ButtonVariant.inverted : ButtonVariant.unselected} 
                  size={null}
                  onClick={() => {
                    handleFilterChange(filter);
                  }}
                  onDoubleClick={() => {
                    handleFilterDoubleClick(filter);
                  }}
                  className="flex-1 h-[40px] px-4 text-sm relative"
              >
                  {getChatFilterName(filter)} 
                  {filtersUnread.includes(filter) && <span className="absolute right-[0px] top-[0px] text-xs bg-brand-red text-white rounded-full w-3 h-3"></span>}
              </Button>
            ))
          }
        </div>
      </div>
    </div>
  );
};